import React, { useState, useEffect } from "react";
import "../css/Navbar.css";
import LOGO from "../img/LOGO.png";
import { Link, NavLink } from "react-router-dom";
import Dropdown from "./Dropdown";

// Por encima de este ancho, los niveles se agrupan en el desplegable "Niveles".
// Por debajo, se listan uno por uno dentro del menú hamburguesa.
const ANCHO_ESCRITORIO = 957;

function Navbar() {
  const [click, setClick] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [esEscritorio, setEsEscritorio] = useState(
    window.innerWidth > ANCHO_ESCRITORIO
  );

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const onMouseEnter = () => setDropdown(window.innerWidth >= 960);
  const onMouseLeave = () => setDropdown(false);

  // Antes esto se resolvía manipulando clases con querySelector y registrando un
  // listener de resize en cada render, sin quitarlo nunca.
  useEffect(() => {
    const alRedimensionar = () =>
      setEsEscritorio(window.innerWidth > ANCHO_ESCRITORIO);

    window.addEventListener("resize", alRedimensionar);
    return () => window.removeEventListener("resize", alRedimensionar);
  }, []);

  const niveles = [
    { ruta: "/inicial", texto: "Inicial" },
    { ruta: "/primario", texto: "Primario" },
    { ruta: "/secundario", texto: "Secundario" },
    { ruta: "/nocturno", texto: "Secundario Acelerado" },
  ];

  return (
    <>
      <nav className="NavbarItems">
        <Link to="/home" className="navbar-logo" onClick={closeMobileMenu}>
          <img
            src={LOGO}
            className="logo-william"
            alt="Logo del Colegio William C. Morris"
          />
          <span className="text-logo">William C. Morris</span>
        </Link>
        {/* Botton-mobile */}
        <div
          className="menu-icon"
          onClick={handleClick}
          role="button"
          tabIndex="0"
          aria-label={click ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={click}
        >
          <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
        </div>
        {/* Items */}
        <div className="content-items">
          <ul className={click ? "nav-menu active topnav-left" : "nav-menu"}>
            <li>
              <NavLink
                to="/home"
                className="nav-links default"
                activeClassName="activo"
                onClick={closeMobileMenu}
              >
                Inicio
              </NavLink>
            </li>
            {/* Desplegable de niveles (solo en escritorio) */}
            {esEscritorio && (
              <li
                className="drop NIV"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
              >
                <NavLink
                  to="/niveles"
                  className="nav-links niveles-drop default"
                  activeClassName="activo"
                  onClick={closeMobileMenu}
                >
                  Niveles <i className="fas fa-caret-down" />
                </NavLink>
                {dropdown && <Dropdown />}
              </li>
            )}
            {/* Niveles sueltos (solo en el menú del celular) */}
            {!esEscritorio &&
              niveles.map((nivel) => (
                <li key={nivel.ruta}>
                  <NavLink
                    to={nivel.ruta}
                    className="nav-links"
                    activeClassName="activo"
                    onClick={closeMobileMenu}
                  >
                    {nivel.texto}
                  </NavLink>
                </li>
              ))}
            <li>
              <NavLink
                to="/RRHH"
                className="nav-links default"
                activeClassName="activo"
                onClick={closeMobileMenu}
              >
                RRHH
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contacto"
                className="nav-links default"
                activeClassName="activo"
                onClick={closeMobileMenu}
              >
                Contacto
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
